import React from 'react';
import moment from 'moment';

import ModulePanel from '../../ModulePanel';

import Table from '../../../components/Table';

import completeWithZero from '../../../services/completeWithZero';

import styled from 'styled-components';

const Results = ({ surveys = [], handleState, onDeleteFeedback }) => {
	return (
		<ModulePanel title={['Formularios']}>
			<Table
				list={surveys}
				defaultSorter={{ parameter: 'startDate', order: 'DESC' }}
				filterFunction={(user) => `${user.name || ''} ${user.status}`}
				iterateFunction={(record, index) => {
					const { findings = 0, isMobile = false } = record,
						findingsLabel =
							findings > 6
								? findings > 8
									? 'Promotor'
									: 'Pasivo'
								: 'Detractor',
						findingsClass =
							findings > 6 ? (findings > 8 ? 'success' : 'warning') : 'danger';

					return (
						<tr key={index}>
							<td className="align-items-center">
								<SatisfactionRatio value={record.avg || 0} />
							</td>
							<td>{record.name || ''}</td>
							<td className="text-center">
								{isMobile && <i className="fas fa-mobile-alt fa-2x" />}

								{!isMobile && <i className="fas fa-laptop fa-2x" />}
							</td>
							<td>
								{!isNaN(record.time) &&
									Math.floor(record.time / 60) +
										':' +
										completeWithZero(
											record.time - Math.floor(record.time / 60) * 60,
											2
										)}
							</td>
							<td>
								{moment
									.unix(record.startDate)
									.format('dddd DD [de] MMMM [de] YYYY, HH:mm:ss')}
							</td>
							<td className="text-center">
								{record.status === 'COMPLETA' && (
									<i className="fas fa-check text-success" />
								)}

								{record.status !== 'COMPLETA' && (
									<i className="fas fa-times text-danger" />
								)}
							</td>
							<td>
								{record.status === 'COMPLETA' && (
									<label className={'badge badge-' + findingsClass}>
										{findingsLabel}
									</label>
								)}
							</td>
							<td
								className="d-flex align-items-center"
								style={{ maxWidth: '190px' }}
							>
								<span
									onClick={() => {
										handleState({ individual: true, individualData: record });
									}}
									className="btn btn-primary btn-sm"
								>
									Ver éste feedback
								</span>
								<button
									onClick={() => {
										onDeleteFeedback(record);
									}}
									className="deleteIcon btn-danger ml-2"
									style={{ padding: '9px 12px 8px', cursor: 'pointer' }}
								>
									<i className="fas fa-trash-alt"></i>
								</button>
							</td>
						</tr>
					);
				}}
				fields={[
					{
						text: 'Indice de Satisfacción',
						sortable: false,
					},
					{
						text: 'Hecho por',
						parameter: 'name',
					},
					{
						text: '',
						sortable: false,
					},
					{
						text: 'Tiempo',
						parameter: 'time',
					},
					{
						text: 'Fecha de inicio',
						parameter: 'startDate',
					},
					{
						text: 'Completada',
						parameter: 'status',
					},
					{
						text: '',
						sortable: false,
					},
					{
						text: '',
						sortable: false,
					},
				]}
			/>
		</ModulePanel>
	);
};

export default Results;

const SatisfactionRatio = ({ value }) => {
	return (
		<ProgressComponent width={(value * 100) / 5}>
			<div></div>
		</ProgressComponent>
	);
};

const ProgressComponent = styled.div`
	background: rgba(0, 0, 0, 0.14);
	border-radius: 4px;
	height: 12px;
	min-width: 90px;
	padding: 1px;
	width: 90px;

	& > div {
		background: var(
			--${(props) => {
					if (props.width < 50) {
						return 'danger';
					} else {
						if (props.width < 80) {
							return 'warning';
						} else {
							return 'success';
						}
					}
				}}
		);
		border-bottom-left-radius: 4px;
		border-top-left-radius: 4px;
		border-bottom-right-radius: ${(props) => (props.width >= 100 ? 4 : 0)}px;
		border-top-right-radius: ${(props) => (props.width >= 100 ? 4 : 0)}px;
		height: 10px;
		width: ${(props) => props.width}%;
	}
`;
